export const userStatuses = {
    ACTIVE: 'Active',
    BLOCKED: 'Blocked',
    NEW: 'New'
}
